import React from 'react';
import { failReasonText } from './runRules';

/**
 * ② 분리+OCR — 읽지 못한 쪽 목록(F9, BE-20260925 §2-1 · dev 1e4eb15).
 *
 * prod #46 은 18쪽이 실패했는데 화면 어디에도 「몇 쪽이 실패했는지」가 없어, 사람이 쪽 번호를 짐작해
 * 범위 칸에 넣었고 세 번 모두 실패한 쪽이 아닌 다른 쪽을 가리켰다. 서버가 이제 ocr-status 에
 * failed_pages[{page_id, file_id, file_name, page_index, page_no, reason, error_msg, attempts}] 를 준다.
 *
 * 쪽마다 [다시 읽기] — 그 파일의 그 한 쪽만 다시 읽는다(run {file_id, page_range:[i,i]}, force 아님 —
 * 실패한 쪽은 force 없이도 다시 대기열에 들어간다). 누르면 곧바로 부르지 않고 ② 의 실행 창을 연다 —
 * 쪽마다 비용이 들고, 출력 잘림은 지시를 바꿔야 다른 결과가 나오기 때문이다.
 *
 * 옛 서버에는 목록이 없다 — 부르는 쪽이 배열이 아니면 그리지 않는다(실패 수는 머리 요약·진행 카드가 말한다).
 */
function FailedPagesList({ failedPages, disabled = false, disabledReason = null, onReread }) {
  if (!Array.isArray(failedPages) || failedPages.length === 0) return null;
  const capped = failedPages.length >= 200; // 서버 상한
  return (
    <div className="mt-3 rounded-2xl border border-red-100 bg-red-50/40 p-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-xs font-medium text-red-700">
          읽지 못한 쪽 {failedPages.length}{capped ? '개 이상' : '개'}
        </p>
        {disabled && disabledReason && <p className="text-[11px] text-gray-400">{disabledReason}</p>}
      </div>
      <ul className="mt-2 space-y-1">
        {failedPages.map((fp) => {
          const r = failReasonText(fp.reason);
          return (
            <li
              key={fp.page_id ?? `${fp.file_id}-${fp.page_index}`}
              className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-gray-700"
            >
              <span className="min-w-0 truncate font-medium" title={fp.file_name || undefined}>
                {fp.file_name || `파일 #${fp.file_id}`}
              </span>
              <span className="shrink-0 tabular-nums">{fp.page_no ?? (Number(fp.page_index) + 1)}쪽</span>
              <span
                className="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-medium text-red-700"
                title={[r.how, fp.error_msg].filter(Boolean).join('\n') || undefined}
              >
                {r.label}
              </span>
              {Number(fp.attempts) > 0 && (
                <span className="shrink-0 text-[11px] text-gray-400">시도 {fp.attempts}회</span>
              )}
              <button
                type="button"
                onClick={() => onReread && onReread(fp)}
                disabled={disabled}
                title={disabled ? (disabledReason || undefined) : `이 쪽만 다시 읽습니다${r.how ? ` — ${r.how}` : ''}`}
                className="ml-auto shrink-0 rounded-full border border-primary px-2.5 py-0.5 text-[11px] font-medium text-primary transition-colors hover:bg-primary/5 disabled:cursor-not-allowed disabled:opacity-40"
              >
                다시 읽기
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default FailedPagesList;
